<template lang="pug">
.RakugoPlayer
  .content
    .result
      .character
      .message
        | あなたは
        .title 「{{ rank.title }}」
        | レベル
      .steps
        .stepItem(:class="{past: rank.id > 0,  current: rank.id === 0 }")
          span.label 見習い
        .stepItem(:class="{past: rank.id > 1, current: rank.id === 1 }")
          span.label 前座
        .stepItem(:class="{past: rank.id > 2, current: rank.id === 2 }")
          span.label 二つ目
        .stepItem(:class="{past: rank.id > 3, current: rank.id === 3 }")
          span.label 真打
      .detail
        .score {{ score }}点
    km-button.backButton(
      size="large"
      styleName="primary"
      @click="handleBackButtonClick"
    ) 戻る


  km-footer(
    backPath="/speedup/rakugo/select"
    title="噺家になろう"
    :navigationDisabled="true"
    :homeButtonEnabled="true"
  )
</template>

<script>
import { mapState } from 'vuex'
// import soundService from '@/services/SoundService'

export default {
  name: 'speedup-select-page',
  components: {},
  data() {
    return {
      level: ''
    }
  },
  computed: {
    ...mapState('User/SpeedUp/Rakugo', {
      result: state => state.result
    }),
    time() {
      if (!this.result || !this.level) return ''
      return this.result[this.level].last.time
    },
    score() {
      if (!this.result || !this.level) return ''
      return this.result[this.level].last.score
    },
    rank() {
      if (!this.result || !this.level)
        return {
          id: 0,
          title: ''
        }
      const lastScore = this.level && this.result[this.level].last.score
      const rank = {
        id: 0,
        title: ''
      }
      switch (true) {
        case lastScore <= 50000:
          rank.id = 0
          rank.title = '見習い'
          break
        case lastScore <= 300000:
          rank.id = 1
          rank.title = '前座'
          break
        case lastScore <= 500000:
          rank.id = 2
          rank.title = '二つ目'
          break
        default:
          rank.id = 3
          rank.title = '真打'
          break
      }
      return rank
    }
  },
  mounted() {
    this.level = this.$route.params.level
  },
  methods: {
    handleBackButtonClick() {
      this.$router.push('/speedUp/rakugo/select')
    }
  }
}
</script>

<style lang="scss" scoped>
.RakugoPlayer {
  width: 100%;
  height: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 80px);
  font-size: 3rem;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: url(../../../assets/speedup/rakugo/bg.png) center center
      no-repeat;
    background-size: cover;
    z-index: -1;
    filter: blur(5px);
  }
}

.result {
  margin: 0 0 40px 0;
  padding: 20px;
  width: 50%;
  border: 10px solid rgba(82, 18, 119, 1);
  background: #fff;
  text-align: center;
  overflow: hidden;
}

.message {
  margin: 0 0 20px 0;
  .title {
    display: inline;
    color: rgba(82, 18, 119, 1);
    font-weight: bold;
  }
}

.character {
  position: relative;
  display: inline-block;
  margin: 0 0 20px 0;
  width: calc(114px * 0.75);
  height: calc(199px * 0.75);
  background: url(../../../assets/speedup/rakugo/hanashika.png) no-repeat;
  background-size: cover;
  z-index: 100;
}

.steps {
  display: flex;
  margin: 0 -40px;
  .stepItem {
    position: relative;
    padding: 15px;
    width: 25%;
    font-size: 2.5rem;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 100%;
      border-top: 2px solid #000;
      border-right: 2px solid #000;
      transform: skew(30deg);
    }
    .label {
      position: relative;
      z-index: 50;
    }
    &.past {
      &::after {
        background: rgba(82, 18, 119, 0.3);
      }
    }
    &.current {
      &::after {
        background: rgba(82, 18, 119, 0.8);
      }
      .label {
        color: #fff;
        font-weight: bold;
      }
    }
  }
}

.detail {
  margin: 0 -20px -20px;
  padding: 10px;
  background: rgba(82, 18, 119, 1);
  color: #fff;
}

.backButton {
  width: 40%;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(/assets/speedUp/rakugo/bg.png) no-repeat;
  background-size: contain;
}
</style>
